(() => {
  const root = document.querySelector('.bp-host');
  if (!root) return;

  const menuButton = root.querySelector('[data-bp-menu-button]');
  const mobileNav = root.querySelector('[data-bp-mobile-nav]');
  if (menuButton && mobileNav) {
    const closeMenu = () => {
      mobileNav.setAttribute('hidden', '');
      menuButton.setAttribute('aria-expanded', 'false');
    };
    menuButton.addEventListener('click', () => {
      const open = mobileNav.hasAttribute('hidden');
      if (open) mobileNav.removeAttribute('hidden');
      else mobileNav.setAttribute('hidden', '');
      menuButton.setAttribute('aria-expanded', String(open));
    });
    mobileNav.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
  }

  root.querySelectorAll('[data-bp-purchase]').forEach((purchase) => {
    const packs = [...purchase.querySelectorAll('[data-bp-pack]')];
    const field = purchase.querySelector('[data-bp-variant-field]');
    const submit = purchase.querySelector('[data-bp-submit]');
    const status = purchase.querySelector('[data-bp-availability-status]');
    if (!packs.length || !field || !submit) return;

    const selectPack = (pack) => {
      packs.forEach((item) => item.setAttribute('aria-pressed', String(item === pack)));
      const variantId = pack.dataset.bpVariant || '';
      const available = pack.dataset.bpAvailable === 'true';
      const label = pack.dataset.bpLabel || 'Selected pack';
      const price = pack.dataset.bpPrice || '';
      field.value = variantId;
      submit.disabled = !variantId || !available;
      submit.textContent = available && variantId ? `Add ${label}${price ? ` · ${price}` : ''}` : 'Unavailable';
      if (status) {
        status.textContent = available ? `${label} selected.` : `${label} is currently unavailable.`;
        status.classList.toggle('bp-availability--visible', !available);
      }
    };

    packs.forEach((pack) => pack.addEventListener('click', () => selectPack(pack)));
    const requestedPack = new URLSearchParams(window.location.search).get('bp_pack');
    const requested = requestedPack ? packs.find((pack) => pack.dataset.bpPackKey === requestedPack) : null;
    selectPack(requested || packs.find((pack) => pack.getAttribute('aria-pressed') === 'true') || packs[0]);
  });
  const scienceBuy = root.querySelector('.bp-science-page .bp-sticky-buy');
  const scienceHero = root.querySelector('.bps-hero');
  const scienceProduct = root.querySelector('.bps-product');
  if (scienceBuy && scienceHero) {
    const updateScienceBuy = () => {
      const heroRect = scienceHero.getBoundingClientRect();
      const productRect = scienceProduct ? scienceProduct.getBoundingClientRect() : null;
      const pastHero = heroRect.bottom <= 24;
      const productVisible = productRect ? productRect.top < window.innerHeight && productRect.bottom > 0 : false;
      scienceBuy.classList.toggle('is-visible', pastHero && !productVisible);
    };
    updateScienceBuy();
    window.addEventListener('scroll', updateScienceBuy, { passive: true });
    window.addEventListener('resize', updateScienceBuy, { passive: true });
  }

})();
